import * as React from 'react';
import classnames from 'classnames';
import { StickyCallToAction, Price } from '@grandvisionhq/common';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { ContactLensesCTA } from '../ContactLensesCTA/ContactLensesCTA.js';
import { LensesPerBox } from '../LensesPerBox/LensesPerBox.js';

const ContactLensesStickyCTA = ({ className  })=>{
    const { displayPrice  } = useProductData();
    const isDiscount = Boolean(displayPrice.discountedPrice);
    var _discountedPrice;
    const priceValue = (_discountedPrice = displayPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : displayPrice.originalPrice;
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: classnames('contact-lenses-sticky-cta', className),
        button: /*#__PURE__*/ React.createElement(ContactLensesCTA, {
            className: "contact-lenses-sticky-cta__button"
        }),
        price: /*#__PURE__*/ React.createElement(Price, {
            value: priceValue,
            currency: displayPrice.currency,
            centAmount: displayPrice.isCentAmount,
            type: isDiscount ? 'discount' : 'default'
        }),
        priceSubtitle: /*#__PURE__*/ React.createElement(LensesPerBox, {
            hideTitle: true
        })
    });
};

export { ContactLensesStickyCTA };
//# sourceMappingURL=ContactLensesStickyCTA.js.map
